import { ThemeMode } from '@modules/theme/constants';
import { Theme } from '@mui/material';
import { useTheme } from '@mui/system';
import { useMemo } from 'react';

const COLOR_B_LIGHT_MODE = '#4993F5';
const COLOR_B_DARK_MODE = '#1A6AFF';

export const useGetCompareColors = () => {
  const theme = useTheme<Theme>();

  const compareColors = useMemo(() => {
    return {
      colorA: theme.palette.primary.main,
      colorB:
        theme.palette.mode === ThemeMode.LIGHT
          ? COLOR_B_LIGHT_MODE
          : COLOR_B_DARK_MODE,
    };
  }, [theme.palette]);

  return compareColors;
};
